// eslint-disable-next-line import/prefer-default-export
export const transmissionTypeFilterName = 'transmissionType';

export const odometerMilesFilterName = 'odometerMiles';

export const odometerKilometersFilterName = 'odometerKilometers';

export const odometerFilterName = 'odometer';

export const fuelTypeFilterName = 'fuelType';

export const typeFilterName = 'type';

export const equipmentLabelFilterName = 'equipmentLabel';

export const featuresFilterName = 'features';

export const engineSizeFilterName = 'engineSize';

export const numDoorsFilterName = 'numDoors';

export const genericColourFilterName = 'genericColour';

export const currentPriceFilterName = 'currentPrice';

export const bodyStyleFilterName = 'bodyStyle';

export const fullTextFilterName = 'fullText';

export const freeTextFilterName = 'freeText';

export const ageFilterName = 'age';

export const conditionFilterName = 'condition';

export const distanceFilterName = 'distance';

export const modelFilterName = 'model';

export const manufacturerFilterName = 'manufacturer';

export const variantFilterName = 'variant';

export const modelVariantFilterName = 'modelVariant';

export const manufacturerModelFilterName = 'manufacturerModel';

export const locationNameFilterName = 'locationName';

export const locationHashFilterName = 'locationHash';

export const franchiseHashFilterName = 'franchiseHash';

export const registrationYearFilterName = 'registrationYear';

export const registrationDateFilterName = 'registrationDate';

export const financesProductFilterName = 'financesProductName';

export const financesTermFilterName = 'financesTerm';

export const financesDepositFilterName = 'financesDeposit';

export const financesAnnualMileageFilterName = 'financesAnnualMileage';

export const financesPaymentFilterName = 'financesPayment';

export const rangeFilterName = 'range';

export const rangeKilometersFilterName = 'rangeKilometers';

export const rangeMilesFilterName = 'rangeMiles';

export const capIdFilterName = 'capId';
